import { ID } from "@libs/interfaces/layouts"

export const GET_DIARIES = ( festId: ID = -1 ) => {

    return `query getDiaries  {
        getPEDiarys ( paging: {count: 5 } land_id: ${festId}) {
            id title post_content thumbnail post_date 
            post_author {id display_name}
        }
    }`
        
} 